export default function loadClientResources (resources) {
    resources['phone-not-valid'] = "Numero di telefono non valido.";
    resources["email"] = "e-mail";
    resources["phone"] = "Telefono";
    resources["title"] = "Titolo";
    resources["message"] = "Messaggio";
    resources["created-at"] = "Creato il";
    
    resources["copied"] = "Copiato";
    resources["image-instructions"] = <>
        <p>Trascina qui un'immagine</p>
        <p><small>Formati supportati .gif, .jpeg, .png</small></p>
    </>;
    
    resources["saving"] = "Salvataggio...";
    resources["close"] = "Chiudi";
    resources["create-item-first"] = "Crea la scheda prima di trasferire l'immagine.";
    resources["confirm-delete-heading"] = "Elimina questa scheda";
    resources["insert"] = "Inserisci";
    resources["create"] = "Crea";
    
    resources["tables"] = "Tabelle";
    resources["social-type"] = "Tipo Social";
    resources["social-types"] = "Tipi Social";
    resources["social"] = "Social";
    resources["socials"] = "Social";
    resources["stream"] = "Stream";
    resources["streams"] = "Stream";
    resources["stream-type"] = "Sorgente Stream";
    resources["stream-types"] = "Sorgenti Stream";
    resources["report"] = "Report";
    resources["reports"] = "Report";
    resources["change"] = "Cambia";
}